<div class="datepicker-header">
    <button mat-icon-button (click)="previousClicked('month')" class="previous-month"></button>
    <span class="datepicker-header-label">{{periodLabel}}</span>
    <button mat-icon-button (click)="nextClicked('month')" class="next-month"></button>
</div>